import { Gutter, Layout, LayoutItem, Paragraph, Well } from '@axiom/ui';
import React from 'react';
import type { AfcSubmissionCandidate } from '@axiom/validation';

import ProfileCheckmark from '../../public/svg/profile-checkmark.svg';

export const doNotShowBannerNames = {
  optedOutDisplay: 'optedOutDisplay',
  limitedFeedbackDisplay: 'limitedFeedbackDisplay',
} as const;

type CandidateReputationDoNotShowBannerProps = {
  name: (typeof doNotShowBannerNames)[keyof typeof doNotShowBannerNames];
  candidate?: AfcSubmissionCandidate;
};

export const CandidateReputationDoNotShowBanner = ({
  name,
  candidate,
}: CandidateReputationDoNotShowBannerProps) => {
  const verbage = {
    [doNotShowBannerNames.optedOutDisplay]: `While ${candidate?.calculatedDisplayName ?? 'Talent'} has chosen to keep their feedback private, we are confident in their skills and believe they are a good match for your opportunity.`,
    [doNotShowBannerNames.limitedFeedbackDisplay]:
      'Although client feedback is not yet available for this talent, we are confident they are a great match for your legal needs.',
  } as const;

  return (
    <Gutter top="24px">
      <Well background="light blue" name={name}>
        <Layout horizontalGutter="16px" position="middle">
          <LayoutItem>
            <ProfileCheckmark width="98" height="93" />
          </LayoutItem>
          <Paragraph>{verbage[name]}</Paragraph>
        </Layout>
      </Well>
    </Gutter>
  );
};
